<template>
  <section>
    <b-loading :active="$apollo.loading || saving === 1" :canCancel="false">
    </b-loading>
    <DeliveryReOrderMap :in-path="mapPath" :addresses="mapAddresses"></DeliveryReOrderMap>
    <div class="container">
      <div class="columns">
        <div class="column">
          <br/>
          <div class="columns">
            <div class="column is-8">
              <h3 class="title is-3">Sorrendezés - {{ weekReadable }} hét {{ decodeId(deliveryRouteId) }}.
                járat</h3>
            </div>
            <div class="column is-4">

              <button class="button is-info" @click="showPath">Térképes nézet</button>
              <button class="button is-info" @click="optimizePath">Útvonal optimalizálása</button>

              <button class="button is-success is-pulled-right" @click="save">Mentés</button>
            </div>
          </div>
          <table class="orderer">
            <thead>
            <tr>
              <th colspan="10">
                Tiszta utazási idő Kucsmától végéig:
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {{ Math.floor(sumTime / 60).toFixed(0) }}:{{ (sumTime % 60).toFixed(0) }}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <input style="max-width: 80px" type="number" v-model.number="minPerStop"> perc / megálással számolva
                {{
                  Math.floor((sumTime + minPerStop * items.length) / 60).toFixed(0)
                }}:{{ ((sumTime + minPerStop * items.length) % 60).toFixed(0) }}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                Új útvonal idő megtakarítása: {{ ((firstTime - sumTime)).toFixed(0) }} perc
              </th>
            </tr>
            <tr>
              <th>Sor</th>
              <th>H</th>
              <th>Kisz.Idősáv</th>
              <th>Azon</th>
              <th>Név</th>
              <th>Irsz.</th>
              <th>Cím</th>
              <th>Ügyintéző</th>
              <th><i class="fas fa-map"></i></th>
              <th>Idő (p)</th>
            </tr>
            </thead>
            <draggable v-model="items" element="tbody"
                       @change="renumber"
                       :options="{draggable:'.dragme', group: 'pr'}">
              <tr :class="{dragme: true, newRow : row.deliveryOrder === 0}" v-for="row in items">
                <td style="text-align: right" v-if="row.deliveryOrder === 0">*&nbsp;&nbsp;</td>
                <td style="text-align: right" v-else>{{ row.deliveryOrder }}&nbsp;&nbsp;</td>
                <td>{{ row.ordering.address.permanentDeliveryRoute.id !== deliveryRouteId ? 'H' : '' }}
                </td>
                <td>{{ row.ordering.address.deliveryTime }}</td>
                <td>{{ decodeId(row.ordering.address.id) }}</td>
                <td>{{ row.ordering.address.client.name }}</td>
                <td>{{ row.ordering.address.zip }}</td>
                <td>{{ row.ordering.address.city }} {{ row.ordering.address.street }}
                  {{ row.ordering.address.extension }}
                </td>
                <td>{{ row.ordering.address.contact }}</td>
                <td>
                  <b-button @click="mapAddresses = [row.ordering.address]"
                            v-if="row.ordering.address.locationLat!=null"><i class="fas fa-map"></i></b-button>
                </td>
                <td>{{ row.time.toFixed(2) }}</td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import gql from 'graphql-tag'
import {
  decodeId,
  encodeId,
  handleResult,
  mutateAll,
  processGraphQLResult,
  processGraphQLResultAndGetArray
} from '../funcs'
import draggable from 'vuedraggable'
import DeliveryReOrderMap from "@/views/DeliveryReOrderMap";
import {getAjax} from "../funcs";
import {latLng} from "leaflet";

export default {
  name: "DeliveryReOrder",
  components: {DeliveryReOrderMap, draggable},
  props: {
    weekId: String,
    deliveryRouteId: String
  },
  data: () => ({
    items: [],
    dist: null,
    saving: 0,
    mapAddresses: [],
    mapPath: [],
    minPerStop: 2,
    firstTime: 0,
  }),
  created() {
    window.onbeforeunload = function () {
      return true;
    };
  },
  methods: {
    renumber() {
      let i = 1
      let passed = false
      this.items.forEach(item => {
        if (item.deliveryOrder > 0 || passed) {
          item.deliveryOrder = i
          i++
          passed = true
        }
      })
    },
    showPath() {
      this.mapAddresses = this.items.map(p => p.ordering.address).filter(p => p.locationLat != null)
      let coords = this.mapAddresses.map(p => p.locationLon + ',' + p.locationLat).join(';')
      let url = '/osm/route/route/v1/driving/' + coords + '?overview=false&steps=true'
      getAjax(url, (a) => {
        let legs = JSON.parse(a).routes[0].legs
        let o = []
        for (let i = 0; i < legs.length; i++) {
          let leg = legs[i]
          o.push(latLng(this.mapAddresses[i].locationLat, this.mapAddresses[i].locationLon))
          leg.steps.forEach(p => {
            o.push(latLng(p.maneuver.location[1], p.maneuver.location[0]))
          })
        }
        let i = legs.length
        o.push(latLng(this.mapAddresses[i].locationLat, this.mapAddresses[i].locationLon))
        this.mapPath = o
      })
      this.mapPath = []
    },
    optimizePath() {
      this.saving = 1
      this.$apollo.query({
        query: gql`query($id: ID!, $week: Int!){optimizeRoute(id: $id, week: $week)}`,
        variables: {
          'id': this.deliveryRouteId,
          'week': this.weekId,
        }
      }).then((a) => {
        let d = JSON.parse(a.data.optimizeRoute)
        this.items.forEach(item => {
          if (item.ordering.address.id in d.orders) {
            item.deliveryOrder = d.orders[item.ordering.address.id]
          } else {
            item.deliveryOrder = -1
          }
        })
        this.items.sort((a, b) => a.deliveryOrder - b.deliveryOrder)
        this.saving = 0
      })
    },
    save() {
      this.saving = 1
      let arr = []
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].deliveryOrder = i + 1
        arr.push({
          addressId: this.items[i].ordering.address.id,
          order: i + 1
        })
      }
      let strData = JSON.stringify(arr)
      this.$apollo.mutate({
            mutation: gql
                `
mutation ($week: String, $data: String, $deliveryRouteId: ID!) {
  saveDeliveryOrder(week: $week, data: $data, deliveryRouteId: $deliveryRouteId) {
    ok
  }
}
`,
            variables: {
              week: this.weekId,
              deliveryRouteId: this.deliveryRouteId,
              data: strData
            }
          }
      ).then(() => {
        this.$router.go(-1)
      }).catch(() => alert('Nem lehet menteni!'))
    },
    decodeId(string) {
      return decodeId(string)
    },
    truncate(message) {
      if (message && message.length > 50) {
        return message.substring(0, 50)
      }
      return message
    }
  },
  computed: {
    weekReadable() {
      let w = this.weekId
      return w.substring(0, 4) + "-" + w.substring(4, 6)
    },
    sumTime() {
      let w = 0
      this.items.forEach(item => {
        if (item.time) {
          w += item.time
        }
      })
      return w
    }
  },
  watch: {
    sumTime() {
      if (this.sumTime > 0 && this.firstTime === 0) {
        this.firstTime = this.sumTime
      }
    },
    items() {
      let last_id = -1
      this.items.forEach(item => {
        if (last_id === -1 || !item.ordering.address.locationLat) {
          item.time = this.dist[0][item.ordering.address.id] / 60
        } else {
          item.time = this.dist[last_id][item.ordering.address.id] / 60
        }
        if (item.ordering.address.locationLat) {
          last_id = item.ordering.address.id
        }
      })
    },
  },
  apollo: {
    items: {
      fetchPolicy: 'no-cache',notifyOnNetworkStatusChange: true, query: gql
          `
query getOrderingItemsForReorder($week: ID!, $route: ID!){
  reOrderOrderingItems(week: $week, deliveryRoute: $route)
  distanceMatrix(week: $week, deliveryRoute: $route)
}
`,
      variables() {
        return {
          week: encodeId('Week', this.weekId),
          route: this.deliveryRouteId
        }
      },
      update(data) {
        let arr = JSON.parse(data.reOrderOrderingItems)
        let obj = {}
        let arr2 = []
        arr.forEach(function (p) {
          if (!obj[p.ordering.address.id]) {
            obj[p.ordering.address.id] = true
            p.time = 0
            arr2.push(p)
          }
        })
        this.dist = JSON.parse(data.distanceMatrix)
        return arr2.sort((a, b) => a.deliveryOrder - b.deliveryOrder)
      }
    }
  }
}
</script>

<style scoped>
table.orderer th {
  text-align: left;
  border-collapse: collapse;
}

table.orderer {
  width: 100%;
}

table.orderer td {
  cursor: move;
}

tr.newRow {
  background-color: rgb(255, 221, 250);
}

table.orderer tr:hover {
  background-color: rgb(169, 222, 255);
}
</style>
